import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { scrollToTop } from "@/lib/useLenis";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollToTop();
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export function SchemaJsonLd({ business }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BeautySalon",
    name: business.name,
    image: business.image || undefined,
    telephone: business.phone,
    email: business.email,
    address: {
      "@type": "PostalAddress",
      streetAddress: business.address.line1,
      addressLocality: "Mansa",
      addressRegion: "Punjab",
      postalCode: "151505",
      addressCountry: "IN",
    },
    openingHours: business.hours.map(
      (h) => `${h.day.slice(0, 2)} ${h.time.replace(" – ", "-")}`
    ),
    priceRange: "₹₹",
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export function PageHead({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
  }, [title, description]);
  return null;
}

export function useCursorHover() {
  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    const cursor = document.createElement("div");
    cursor.className = "gl-cursor";
    document.body.appendChild(cursor);
    const move = (e) => {
      cursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px) translate(-50%, -50%)`;
    };
    const over = (e) => {
      if (e.target.closest("a, button, [role='button'], input, textarea, select, label")) {
        cursor.classList.add("is-hover");
      } else {
        cursor.classList.remove("is-hover");
      }
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      cursor.remove();
    };
  }, []);
}

export function useState_() { return useState(); }
